import { render, staticRenderFns } from "./FiltrosAgendamentoMedico.vue?vue&type=template&id=d0612f80&scoped=true"
import script from "./FiltrosAgendamentoMedico.vue?vue&type=script&lang=ts"
export * from "./FiltrosAgendamentoMedico.vue?vue&type=script&lang=ts"
import style0 from "./FiltrosAgendamentoMedico.vue?vue&type=style&index=0&id=d0612f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0612f80",
  null
  
)

export default component.exports